/*公共配置文件*/
import { getDomain } from '@/assets/js/tool'

//参与运算的加密参数
const KEY = 'QWYIWEODCHIDHSKDHKXCHSTW8RELVJCXJSUW893I3FJLSFDKSDL789DFGJKDFG'

var userAgentt = navigator.userAgent.toLowerCase()
let BARCONF = [];

// 判断是否在微信中打开
if (userAgentt.indexOf('micromessenger') == -1) {
  //navbar配置
  BARCONF = [
    {
      name: 'home',
      path: '/home',
      pic: 'https://ctdsb.clouddiffuse.xyz/activity/baiguan/btn/menu1.png',
      txt: '首页',
      icon: 'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/home.png',
      icon_c: 'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/home-c.png',
    },
    {
      name: 'bases',
      path: '/bases/list',
      pic: 'https://ctdsb.clouddiffuse.xyz/activity/baiguan/btn/menu1.png',
      txt: '基地',
      icon: 'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/base.png',
      icon_c: 'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/base-c.png',
    },
    {
      name: 'venue',
      path: '/venue/list?id=1690303270418046977',
      pic: 'https://ctdsb.clouddiffuse.xyz/activity/baiguan/btn/menu2.png',
      txt: '展馆',
      icon: 'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/venue.png',
      icon_c:
        'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/venue-c.png',
    },
    {
      name: 'lesson',
      path: '/article/news/index',
      pic: 'https://ctdsb.clouddiffuse.xyz/activity/baiguan/btn/menu3.png',
      txt: '课堂',
      icon: 'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/lesson.png',
      icon_c:
        'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/lesson-c.png',
    },
    // {
    //     name: 'personal',
    //     path: '/personal/index',
    //     pic: 'https://ctdsb.clouddiffuse.xyz/activity/baiguan/btn/menu4.png',
    //     txt: '我的',
    //     icon: 'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/user.png',
    //     icon_c:'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/user-c.png'
    // },
    {
      name: 'inquiry',
      path: '/inquiry/index',
      pic: 'https://ctdsb.clouddiffuse.xyz/activity/baiguan/btn/menu5.png',
      txt: '查询',
      icon: 'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/search.png',
      icon_c:
        'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/search-c.png',
    },
  ]
} else {
  //navbar配置
  BARCONF = [
    {
      name: 'home',
      path: '/home',
      pic: 'https://ctdsb.clouddiffuse.xyz/activity/baiguan/btn/menu1.png',
      txt: '首页',
      icon: 'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/home.png',
      icon_c: 'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/home-c.png',
    },
    {
      name: 'bases',
      path: '/bases/list',
      pic: 'https://ctdsb.clouddiffuse.xyz/activity/baiguan/btn/menu1.png',
      txt: '基地',
      icon: 'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/base.png',
      icon_c: 'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/base-c.png',
    },
    {
      name: 'venue',
      path: '/venue/list?id=1690303270418046977',
      pic: 'https://ctdsb.clouddiffuse.xyz/activity/baiguan/btn/menu2.png',
      txt: '展馆',
      icon: 'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/venue.png',
      icon_c:
        'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/venue-c.png',
    },
    {
      name: 'lesson',
      path: '/article/news/index',
      pic: 'https://ctdsb.clouddiffuse.xyz/activity/baiguan/btn/menu3.png',
      txt: '课堂',
      icon: 'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/lesson.png',
      icon_c:
        'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/lesson-c.png',
    },
    {
        name: 'personal',
        path: '/personal/index',
        pic: 'https://ctdsb.clouddiffuse.xyz/activity/baiguan/btn/menu4.png',
        txt: '我的',
        icon: 'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/user.png',
        icon_c:'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/user-c.png'
    },
    {
      name: 'inquiry',
      path: '/inquiry/index',
      pic: 'https://ctdsb.clouddiffuse.xyz/activity/baiguan/btn/menu5.png',
      txt: '查询',
      icon: 'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/search.png',
      icon_c:
        'https://ctdsb.clouddiffuse.xyz/activity/politic/icon/search-c.png',
    },
  ]
}

//公众号的APPID
const APPID = 'wx1d5a35547b3b6f0d'

//公众号授权后的回调地址

let tempauthh = 'http://wx.abcvote.cn/wxAuth.php';
if(window.location.protocol === "https:") {
  tempauthh = 'https://wx.abcvote.cn/wxAuth.php';
}

const REDIRECT = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${encodeURIComponent(
  tempauthh
)}&response_type=code&scope=snsapi_userinfo`

export { KEY, BARCONF, REDIRECT }
